(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this._leaving = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.freezeForNavigation = this.freezeForNavigation.bind(this);
      this.onNavigatePointer = this.onNavigatePointer.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      document.addEventListener('touchmove', this.onScrollHandler, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('scroll', this.onScrollHandler, { passive: true });
      }
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.addEventListener('pointerdown', this.onNavigatePointer, true);
      window.addEventListener('beforeunload', this.freezeForNavigation);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('touchmove', this.onScrollHandler);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', this.onScrollHandler);
      }
      document.removeEventListener('pointerdown', this.onNavigatePointer, true);
      window.removeEventListener('beforeunload', this.freezeForNavigation);
    }

    onNavigatePointer(event) {
      const link = event.target?.closest?.('a[href]');
      if (!link || event.defaultPrevented) return;
      if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
      try {
        const next = new URL(link.href, window.location.href);
        if (next.origin !== window.location.origin) return;
        // Same path (filters, pagination, search params) is often AJAX —
        // freezing there permanently kills sticky header until reload.
        if (next.pathname === window.location.pathname) return;
      } catch (err) {
        return;
      }
      this.freezeForNavigation();
    }

    freezeForNavigation() {
      if (this._leaving) return;
      this._leaving = true;
      document.documentElement.style.scrollBehavior = 'auto';
      this.header.classList.add('is-leaving');
      this.header.classList.remove('animate', 'shopify-section-header-hidden');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0) this.header.classList.add('shopify-section-header-sticky');
    }

    measureHeaderBounds() {
      if (!this.header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const rect = this.header.getBoundingClientRect();
      this.headerBounds = {
        top: Math.max(0, scrollTop + rect.top),
        bottom: Math.max(1, scrollTop + rect.bottom)
      };
    }

    isPhoneViewport() {
      try {
        if (window.matchMedia('(max-width: 749px)').matches) return true;
      } catch (err) {}
      return !!(theme && theme.config && theme.config.mqlSmall);
    }

    createObserver() {
      this.measureHeaderBounds();
      if (this.dataset.scrollUp !== undefined) {
        this.scrollUpActive = true;
      }

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          this.measureHeaderBounds();
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    menuIsOpen() {
      const b = document.body.classList;
      return (
        b.contains('menu-mobile--open') ||
        b.contains('menu-mobile--opening') ||
        b.contains('menu-mobile--closing')
      );
    }

    onScroll() {
      if (this._leaving || this.menuIsOpen()) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.headerBounds || !this.headerBounds.bottom) {
        this.measureHeaderBounds();
      }

      // Phone uses CSS position:sticky. Only toggle the white "scrolled" class.
      if (this.isPhoneViewport()) {
        if (scrollTop > 8) {
          if (!this.sticky()) this.reveal();
        } else if (this.header.classList.contains('shopify-section-header-sticky')) {
          this.reset();
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          requestAnimationFrame(this.reveal.bind(this));
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.menuIsOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
